// extracted by mini-css-extract-plugin
export default {"link":"yB-z","disabled":"zB-z"};